<app-reactive-dialog-content [data]="dialogInputData">
  <p class="mat-subheading-2 gsm-virus-warning_wrapper">
    <mat-icon color="warn" class="gsm-virus-warning_icon" inline>warning</mat-icon>
    <span [innerHTML]="dialogInputData.data"></span>
  </p>
  <div class="button-container">
    <button mat-raised-button color="accent" (click)="close()">Zurück</button>
  </div>
</app-reactive-dialog-content>
